import axios from 'axios'
import * as utils from 'src/apis/apiUtils'

export default {
  index(params) {
    return axios.get(utils.getApiUrl('/masters/rosenjimusho'), {
      params: params || {}
    })
  },
  create({ data }) {
    return axios.post(utils.getApiUrl('/masters/rosenjimusho'), data)
  },
  update({ id, data }) {
    return axios.put(utils.getApiUrl(`/masters/rosenjimusho/${id}`), data)
  },
}
